import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  groupId: Yup.string().required('Group is required'),
  sensorIds: Yup.string().required('Choose at least 1 sensor'),
});
